const texts = {
  separator: '-',
  userName: ' by {name}',
  note: '• Note: {note}',
};

export default texts;
